import { Injectable } from '@angular/core';
import { Config } from './universal-config';

@Injectable()
export class MetricsService {

  constructor (private config: Config) {}
  
  sendTiming = async (metricName: string, time: number) => {
    console.log(`⭐️ ${metricName}: ${time}ms`)
    const statsdProxy = this.config.get('STATSD_PROXY')
    if (this.config.get('N_ENV') !== 'prod' || !statsdProxy)  return false;
    const statsdUrl = `${statsdProxy}/timing/${metricName}`
    fetch(statsdUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      body: `time=${time}`
    })
  }
}